export type TimeRange = { from: string; to: string };
export type TimeRangeErrors = Partial<Record<keyof TimeRange, string>>;

export const TIME_PRESETS = [
  { id: 'any', label: 'Любое время', range: { from: '', to: '' } },
  { id: 'morning', label: 'До 14:00', range: { from: '', to: '14:00' } },
  { id: 'afternoon', label: 'С 14:00', range: { from: '14:00', to: '' } },
] as const;

export function validateTimeRange(range: TimeRange): TimeRangeErrors {
  const errors: TimeRangeErrors = {};
  for (const field of ['from', 'to'] as const) {
    if (range[field] && !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(range[field])) {
      errors[field] = 'Укажите время в формате ЧЧ:ММ.';
    }
  }
  if (!Object.keys(errors).length && range.from && range.to && range.from >= range.to) {
    errors.to = 'Время «до» должно быть позже времени «с» в тот же день.';
  }
  return errors;
}

export function matchesTimeRange(startsAt: string, timezone: string, range: TimeRange): boolean {
  if (Object.keys(validateTimeRange(range)).length) return false;
  const date = new Date(startsAt);
  if (!Number.isFinite(date.getTime())) return false;
  const time = new Intl.DateTimeFormat('en-GB', {
    timeZone: timezone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(date);
  return (!range.from || time >= range.from) && (!range.to || time < range.to);
}
